import { render, staticRenderFns } from "./GenericClientContact.vue?vue&type=template&id=f8fed4c0"
import script from "./GenericClientContact.vue?vue&type=script&lang=js"
export * from "./GenericClientContact.vue?vue&type=script&lang=js"
import style0 from "./GenericClientContact.vue?vue&type=style&index=0&id=f8fed4c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports